import App from '@/App';
import { ROUTES } from '@/configs/constants';
import { withAuthentication } from '@/hooks/withAuthentication';
import AdminPanelLayout from '@/layouts/AdminPanelLayout';
import FormPanelLayout from '@/layouts/FormPanelLayout';
import {
    CompanyManager,
    FileManagementPage,
    FileUploadPage,
    LoginPage,
    NotFoundPage,
    PrivacyPolicyPage,
    UserManagementPage,
    StartPage
} from '@/pages';
import { roleIdEnum } from '@/types/enums';
import { createBrowserRouter } from 'react-router-dom';

const AdminPanelLayoutWithAuthentication = withAuthentication(AdminPanelLayout);

export const router = createBrowserRouter([
    {
        path: '/',
        element: <App />,
        children: [
            {
                path: '/',
                children: [
                    {
                        path: '',
                        element: <StartPage />
                    }
                ]
            },
            {
                path: '/',
                element: <FormPanelLayout />,
                children: [
                    {
                        path: ROUTES.login.href,
                        element: <LoginPage />
                    }
                ]
            },
            {
                path: '/',
                children: [

                    {
                        path: ROUTES.privacyPolicy.href,
                        element: <PrivacyPolicyPage />
                    }
                ]
            },
            {
                path: '/',
                element: <AdminPanelLayoutWithAuthentication roles={[roleIdEnum.adminSystem]} />,
                children: [
                    {
                        path: ROUTES.companyManager.href,
                        element: <CompanyManager />
                    }
                ]
            },
            {
                path: '/',
                element: <AdminPanelLayoutWithAuthentication roles={[roleIdEnum.adminCompany]} />,
                children: [
                    {
                        path: ROUTES.userManagement.href,
                        element: <UserManagementPage />
                    },
                    {
                        path: ROUTES.fileUpload.href,
                        element: <FileUploadPage />
                    },
                    {
                        path: ROUTES.fileManagment.href,
                        element: <FileManagementPage />
                    }
                ]
            },
            {
                path: '*',
                element: (
                    <AdminPanelLayout>
                        <NotFoundPage />
                    </AdminPanelLayout>
                )

            }
        ]
    }
]);
